// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class DispatchCustomerAgg {
  readonly status: string;
  readonly count: number;

  constructor(data: { [key: string]: any } = {}) {
    this.status = data.status === undefined ? '' : data.status;
    this.count = data.count === undefined ? 0 : data.count;
  }

  static zero(): DispatchCustomerAgg {
    const zeroValues: ExcludeMethodsDeep<DispatchCustomerAgg> = {
      status: '',
      count: 0,
    };
    return new DispatchCustomerAgg(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type DispatchCustomerAggWireFormat = {
  status: string;
  count: number;
};

type NewDispatchCustomerAggProps = PartialDeep<DispatchCustomerAgg, { recurseIntoArrays: true }>;
export const NewDispatchCustomerAgg: (props: NewDispatchCustomerAggProps) => DispatchCustomerAgg = (
  props,
) => new DispatchCustomerAgg(props);

type NewDispatchCustomerAggFromWireFormatProps = PartialDeep<
  DispatchCustomerAggWireFormat,
  { recurseIntoArrays: true }
>;
export const NewDispatchCustomerAggFromWireFormat: (
  props: NewDispatchCustomerAggFromWireFormatProps,
) => DispatchCustomerAgg = (props) => new DispatchCustomerAgg(props);
